import { ActionButton } from "../components/ActionButton";

export function HomePage() {
  return (
    <article className="oac-home-page">
      <div className="oac-home-content oac-home-page__inner">
        <h1 className="oac-home-heading oac-home-page__heading">
          Publish your
          <br className="oac-mobile-line-break" />
          {" "}app.{" "}
          <span className="oac-home-heading__accent oac-home-page__heading-accent">
            Simply.
          </span>
        </h1>

        <p className="oac-home-subheading oac-home-page__intro">
          Be among the first publishers
          <br className="oac-mobile-line-break" />
          {" "}on OpenAppCart.
        </p>

        <div className="oac-home-copy oac-home-page__body-copy">
          <p>
            OpenAppCart is a simple web-based platform where anyone can publish
            Android apps in minutes. Whether you&apos;re a student, freelancer,
            startup founder, homemaker, retired professional, or experienced
            developer, If you can upload a photo, you can publish your android
            app. You own your app. You choose your payment provider. You control
            your updates. You can even list your app for sale.
          </p>

          <p className="oac-home-copy__strong oac-home-page__promise">
            No approvals. No commissions. Just publish.
          </p>
        </div>

        <div className="oac-home-actions oac-home-page__actions">
          <ActionButton
            className="oac-home-page__button"
            to="/sign-in"
            variant="primary"
          >
            Publisher Sign In
          </ActionButton>

          <ActionButton
            className="oac-home-page__button oac-home-page__button--discover"
            to="/discover-apps"
            variant="secondary"
          >
            Discover Apps
          </ActionButton>
        </div>
      </div>
    </article>
  );
}
